import React from 'react';
import styled from 'styled-components';

const TextHeight = styled.div`
  margin-bottom: 24px;
  color: var(--inputTxtColor);
  width: 100%;
`;

const Text = styled.textarea`
  font-size: 14px;
  color: ${(props) => (props.darkTheme && props.isFromModal ? props.theme.txtPrimary : props.darkTheme ? props.theme.inputsColor : 'var(--inputTxtColor)')};
  background: ${(props) =>
    props.disabled && props.darkTheme
      ? props.theme.selectionBg
      : props.disabled && !props.darkTheme
      ? 'var(--light)'
      : props.darkTheme && props.isFromModal
      ? 'var(--dark)'
      : props.darkTheme
      ? props.theme.cardBg
      : '#fff'};
  border: 1px solid ${(props) => (props.darkTheme ? props.theme.borderColor : 'var(--greyBorderColor)')};
  border-radius: 4px;
  width: 100%;
  height: 100px;
  padding: 8px;
  padding-left: 10px;
  cursor: ${(props) => props.disabled && 'not-allowed'};
  :hover {
    outline: none;
    border: ${(props) =>
      props.disabled && props.darkTheme
        ? `1px solid ${props.theme.borderColor}`
        : props.disabled && !props.darkTheme
        ? '1px solid var(--greyBorderColor)'
        : '1px solid var(--brandColor)'};
  }
  :focus {
    outline: none;
    border: ${(props) =>
      props.disabled && props.darkTheme
        ? `1px solid ${props.theme.borderColor}`
        : props.disabled && !props.darkTheme
        ? '1px solid var(--greyBorderColor)'
        : '2px solid var(--brandColor)'};
  }
  @media (min-width: 768px) {
    padding-left: 12px;
  }
`;

const TextArea = ({ style, containerStyle, label, value, onChange, error, placeholder, disabled, maxLength, darkTheme, isFromModal }) => (
  <TextHeight style={containerStyle}>
    <label>{label}</label>
    <Text
      disabled={disabled}
      style={style}
      value={value}
      error={error}
      onChange={onChange}
      placeholder={placeholder}
      maxLength={maxLength || '1000'}
      darkTheme={darkTheme}
      isFromModal={isFromModal}
    />
  </TextHeight>
);

export default TextArea;
